import React from "react";

function AttendanceSkeleton() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="space-y-4 p-4">
        <div className="h-8 w-56 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {Array.from({ length: 10 }).map((_, index) => (
            <div
              key={index}
              className="h-[260px] animate-pulse rounded-2xl bg-slate-100 dark:bg-white/10"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AttendanceSkeleton;